import React from 'react'
import { Link, useStaticQuery, graphql } from 'gatsby'

import Layout from '../../components/layout'
import SEO from '../../components/seo'
import blogStyles from './styles.module.scss'
import PageBanner from '../../components/pageBanner'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'

const BlogPage = () => {
  const data = useStaticQuery(graphql`
    query {
      allContentfulBlogPosts(sort: { fields: date, order: DESC }) {
        edges {
          node {
            date(fromNow: true)
            slug
            title
            category
            image {
              file {
                url
              }
            }
          }
        }
      }
      contentfulPageBanners(slug: { eq: "blog" }) {
        title
        description {
          json
        }
      }
    }
  `)

  return (
    <Layout>
      <SEO title="Alexander Jung Website Blog Page" />
      <PageBanner
        pageTitle={data.contentfulPageBanners.title}
        pageShortDescription={documentToReactComponents(
          data.contentfulPageBanners.description.json,
        )}
      />

      <div className={blogStyles.blogContainer}>
        <div className={blogStyles.posts}>
          {data.allContentfulBlogPosts.edges.map(edge => {
            return (
              <div className={blogStyles.post} key={edge.node.slug}>
                <div>
                  {edge.node.image && (
                    <img
                      src={edge.node.image.file.url}
                      alt={edge.node.title}
                      className={blogStyles.blogImg}
                    />
                  )}
                </div>
                <div className={blogStyles.postTitlesAndBtn}>
                  <h2>
                    <Link to={`/blog/${edge.node.slug}`}>
                      {edge.node.title}
                    </Link>
                  </h2>
                  <p>{edge.node.category}</p>
                  <div className={blogStyles.dateBtnContainer}>
                    <p>
                      <em>Published: {edge.node.date}</em>
                    </p>
                    <button className={blogStyles.button}>
                      <Link to={`/blog/${edge.node.slug}`}> Learn More </Link>
                    </button>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </Layout>
  )
}

export default BlogPage
